import React, { useState, useRef, useEffect } from 'react';
import Header from './Header/Header';
import Sidebar from './Layout/Sidebar';
import NavigationComponent from './Layout/NavigationComponent';
import { useSelector } from "react-redux";
import UpArrow from "../assets/images/Icons/up_arrow.svg"
const HomePage = (props) => {
  const { setLoginHeader } = props
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [isPagescroll, setPagescroll] = useState(false);
  const scrollRef = useRef(null);
  // Function to check if the element has been scrolled more than 30px
  const checkScrollPosition = () => {
    if (scrollRef.current.scrollTop > 30) {
      setPagescroll(true);
    } else {
      setPagescroll(false);
    }
  };
  const BacktoTop = () => {

    scrollRef.current.scrollTo({
      behavior: "smooth",
      top: 0,
    });

  }
  useEffect(() => {

    const element = scrollRef.current;
    // Add the scroll event listener
    element.addEventListener('scroll', checkScrollPosition);

    // Clean up the event listener when the component unmounts
    return () => {
      element.removeEventListener('scroll', checkScrollPosition);
    };
  }, [])
  
  const currentStep = useSelector((state) => state.paginationData.currentStep)

  return (
    <div className="homepage">
      <Header setLoginHeader={setLoginHeader} />
      <div className={`main ${
        currentStep === 2 || currentStep ===3 || currentStep===4? "lobby-fixed" : ""
        }`} ref={scrollRef} >
        {isSidebarVisible && <Sidebar />}
        <div className='main_content_wrapper'>
          <NavigationComponent setSidebarVisible={setSidebarVisible} />
        </div>
      </div>
      {
        device === "Mobile" && isPagescroll && <button className='backtotop_btn btn' style={{ flexShrink: 0 }} onClick={BacktoTop}><img src={UpArrow} alt="" /></button>
      }
    </div>
  );
};
export default HomePage;